module.exports = __webpack_public_path__ + "img/tuurro.t6.f8.431b5d27.png";